import React from 'react';
import styled from 'astroturf/react';

import SpinnerIcon from './icons/spinner.svg';
import _SpinnerWrapper from "Spinner-SpinnerWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/Spinner.tsx?styleId=SpinnerWrapper";


const SpinnerWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "SpinnerWrapper",
  styles: _SpinnerWrapper
});

export type SpinnerProps = {
  size?: number;
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 48 }) => {
  return (
    <SpinnerWrapper style={{ width: size, height: size }}>
      <SpinnerIcon />
    </SpinnerWrapper>
  );
};
